import {
  ApplicationQuestion,
  ApplicationSection,
  CommonQuestionKeys,
  IntroPage,
} from '@bybeam/platform-types';
import { ApplicationConfigDefinitions } from '../../config.js';

export enum SpecialQuestionKeys {
  BankAccount = 'bankAccount',
  W9 = 'w9',
}

export enum SpecialSectionKeys {
  AdminOnly = 'adminOnly',
  Review = 'review',
}

type QuestionKeys = Extract<
  CommonQuestionKeys,
  | CommonQuestionKeys.APPLICATION_ASSISTANCE_HELPER
  | CommonQuestionKeys.DATE_OF_BIRTH
  | CommonQuestionKeys.GENDER
  | CommonQuestionKeys.MAILING_ADDRESS
  | CommonQuestionKeys.RACE
  | CommonQuestionKeys.HOUSEHOLD_MEMBERS
  | CommonQuestionKeys.PREFERRED_PAYMENT_METHOD
  | CommonQuestionKeys.ADDRESS
>;

export interface StandardComponents extends ApplicationConfigDefinitions {
  definitions: {
    introPages: {
      ApplicationProcess: IntroPage;
    };
    questions: { [key in QuestionKeys]: ApplicationQuestion };
    sections: {
      [SpecialSectionKeys.Review]: ApplicationSection;
    };
  };
}
